/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetStandardTestsResponseDto } from '../../models/get-standard-tests-response-dto';

export interface ClinicPathwaysControllerGetStandardTests$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Clinic identifier
 */
  clinicId: string;
}

export function clinicPathwaysControllerGetStandardTests(http: HttpClient, rootUrl: string, params: ClinicPathwaysControllerGetStandardTests$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStandardTestsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, clinicPathwaysControllerGetStandardTests.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('clinicId', params.clinicId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetStandardTestsResponseDto>;
    })
  );
}

clinicPathwaysControllerGetStandardTests.PATH = '/thalea-pathways/clinic-pathways/{tenant}/{clinicId}';
